import { PhotoReviewStateModel } from '../../photo-review/state/model/photo-review-state.model';
import { RevisedFieldModel } from '../../model/revised-fields.model';
import { OrderDetailModel } from './order-detail.model';
import { VirtualTourModel } from '../../virtual-tour/state/model/virtual-tour.model';
import { PublicRecordModel } from '@cv-invision/cv.invision-views.ux';

export const OrderCI_STATE_PATH = 'quality';

export class QualityStateModel {
	orderDetail?: OrderDetailModel;
	photoReview?: PhotoReviewStateModel;
	documentOrder?: any;
	documentSchema?: any;
	isRecalled?: boolean;
	revisedFields?: RevisedFieldModel;
	virtualTour?: VirtualTourModel;
	selectedSection?: any;
	stateEnum?: any;
	menu?: any[]; // TODO: Review if it match the new menu component
	publicRecords?: {
		records: PublicRecordModel[];
	}

	constructor() {
		this.orderDetail = new OrderDetailModel();
		this.photoReview = new PhotoReviewStateModel();
		this.documentOrder = null;
		this.documentSchema = null;
		this.isRecalled = false;
		this.revisedFields = new RevisedFieldModel();
		this.virtualTour = new VirtualTourModel();
		this.selectedSection = null;
		this.publicRecords = {
			records: []
		};
	}
}
